import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { obtenerGruposClaveViajeAction } from "../../../ducks/aereosDuck"
import TGrupoAereo from "../TGrupoAereo"
import { onLoadAnction, offLoadAction} from "../../../ducks/loadDuck"
const VGrupoAereo = () => {
    const { ClavePaquete } = useParams()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({message: "Cargando grupos aereos..."}))
        dispatch(obtenerGruposClaveViajeAction({ claveViaje: ClavePaquete })).then(() => {
            dispatch(offLoadAction())
        })
    }, [dispatch, ClavePaquete])
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Aereos</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupoAereo />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VGrupoAereo